import { render, staticRenderFns } from "./OrderDetailsView.vue?vue&type=template&id=a814f1e0&scoped=true&"
import script from "./OrderDetailsView.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailsView.vue?vue&type=style&index=0&id=a814f1e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a814f1e0",
  null
  
)

export default component.exports